<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    丹竹头站<br>
站点介绍<br>
丹竹头站位于深圳市龙岗区南湾街道龙岗大道上方，西南侧（A出入口）为黄金北路；东南侧（B出入口）为东部星悦天地商场；西北侧（D出入口）为宝冠路；东北侧（C出入口）为丹竹大道。车站出入口附近包含了大量居住区例如：南岭村、时光里、英郡年华、宝岭大厦、荔枝花园、中兆花园、佳年华购物广场等，还包含一个大型购物商场：东部星悦天地。 丹竹头站以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。此站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:02	23:29	3号线	2分15-20秒	4分30秒<br>
双龙	06:20	23:43	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:04	23:29	3号线	3分15秒	5分钟<br>
双龙	06:28	23:43	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:04	00:29	3号线	3分15秒	5分钟<br>
双龙	06:28	00:43	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
龙岗大道南侧（西）、金龙花园、丹竹头汽车站、南岭派出所、南岭村、丹竹头社区、英郡年华（A出入口立柱牌未体现）<br><br>
B出入口:<br>
龙岗大道南侧（东）、时光里、英郡年华、南湾丹竹头小学<br><br>
C出入口:<br>
龙岗大道北侧（东）、圆墩小区、丹竹头社区、丹竹大道<br><br>
D出入口:<br>
龙岗大道北侧（西）、康桥花园、李朗路、立信工业园、宝冠路<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 丹竹头地铁站<br>
8、61、357、366、B882、M139、M172、M180、 M233、M239、M491、M498、M547、高峰专线89、M283、M295、M324、M329、M358、M485、 M154、M380、M415、高峰专线29、M190、高峰专线183、高快巴士86<br><br>
C出入口:<br>
公交站名： 丹竹头地铁站<br>
深惠3A、M154、M172、M283、M415、M490、高峰专线183、甘坑客家小镇假日专线2<br><br>
D出入口:<br>
公交站名： 丹竹头地铁站<br>
M239、M324、M329、M358、M491、61、357、M139、M233、366，M295、M485、M547、8、M150、M180、M380、高峰专线89、M190、高快巴士86、高快巴士48<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>